import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TemplateMasterService } from '../../template-master.service';
import { EditorEventService } from 'src/app/services/editor-event.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicSectionService } from 'src/app/services/dynamicsection.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PageData, Section } from '../editor.modal';
import { FontFamilyList } from '../template-constants';
import { PageListComponent } from '../page-list/page-list.component';
import { WarningPopupComponent } from '../popups/warning-popup/warning-popup.component';
import { CreateNewPageComponent } from '../create-new-page/create-new-page.component';
import { EventEmmiterService } from '../../../../../../services/event-emmiter.service';
import { AddPageV3Component } from '../../pages/add-page-v3/add-page-v3.component';
import { UploadTemplateThumbnailComponent } from '../upload-template-thumbnail/upload-template-thumbnail.component';

@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.scss']
})
export class CreateTemplateComponent {
  //  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  readonly fontFamilies = FontFamilyList;
  selectedOption: any;
  status: any
  constructor(
    private templateService: TemplateMasterService,
    private eventService: EditorEventService,
    private snackBar: MatSnackBar,
    private router: Router,
    private websiteService: DynamicSectionService,
    public ds: DomSanitizer,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private _eventService: EventEmmiterService

  ) {
    this.getScreenSize();
  }
  data: any;
  scrWidth: any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.scrWidth = window.innerWidth;
  }
  // fontFamilies = v3FontFamiliesAfterSignup

  businessDetails: any;
  websiteStatus: any;
  private templateId: string | null = null;
  selectedPage: string | null = null;
  currentPageId: string = '';
  getWebsiteLoader: boolean = true;
  templateData: any = {};
  currentPageIndex: number = 0;
  desc: string = '';
  subIndustryId?: string;
  websiteType: 'STATIC' | 'E_COMMERCE' = 'STATIC';
  ngOnInit() {
    this.dialog.closeAll();
    this.route.queryParamMap.subscribe(qp => {
      this.data = qp['params'];
    });
    localStorage.setItem('subIndustryId', this.data.subIndustryId);
    if (this.data.edit == "false") {
      this.templateData['name'] = this.data.name;
      this.templateData['subIndustry'] = {
        id: this.data.subIndustryId,
        name: this.data.subIndustryName
      }
      this.templateData['type'] = this.data.websiteType;
      this.templateData['desc'] = this.data.desc;
      this.createTemplate();
    } else {
      this.getTemplateById(this.data.id);
    }
    if (this.data.edit === "false" && this.data.preview === "true") {
      this.getTemplateById(this.data.id)
    }
    this.websiteType = this.data.websiteType
    this.getThemePallet();
  }

  downloadExcel() {
    this.templateService.downloadExcelPrompts(this.templateData.id, this.templateData.name).subscribe(
      (blob: any) => {
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `${this.templateData.name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(downloadUrl);
      }
    )
  }

  onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      this.templateService.uploadExcelPrompts(this.templateData.id, file).subscribe({
        next: (response) => {
          // console.log('Upload successful', response);
          this.snackBar.open(response.data, 'Ok', { duration: 2000 })
        },
        error: (error) => {
          // console.error('Upload failed', error);
          this.snackBar.open(error.error.message, 'Close', { duration: 2000 })
        },
      });
    }
  }




  editComponent(item: any) {
    let bDetails: any = { type: item.type };
    localStorage.setItem('bDetails', JSON.stringify(bDetails));

    this.data = { edit: true, id: item.id, subIndustryId: item.subIndustry.id, subIndustryName: item.subIndustry.name, name: item.name };
  }


  templatePage: any[] = []
  createTemplate() {
    this.templateData['staff'] = {
      staffId: localStorage.getItem('staffId') || '',
      staffType: localStorage.getItem('staffType') || 'ADMIN'
    }
    this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
      this.templateData = res.data;
      this.templatePage = this.templateData.pages;
      this.unActivateLink(this.templatePage[0].id)
      this.selectedPage = this.templatePage[0].pageName
      this.currentPageId = this.templatePage[0].id
    })
  }

  getTemplateById(id: any) {
    this.templateService.getTemplateById(id).subscribe((res: any) => {
      this.templateData = res.data;
      this.templatePage = this.templateData.pages;
      this.unActivateLink(this.templatePage[0].id)
      this.selectedPage = this.templatePage[0].pageName
      this.currentPageId = this.templatePage[0].id
      this.applyFontFamily();
    })
  }

  applyFontFamily() {
    document.documentElement.style.setProperty('--website-font-family', Object.keys(this.templatePage[0]?.fonts[0])?.[0]);

    // if (this.templatePage[0]?.fonts && this.templatePage[0]?.fonts[0]) {
    //   Object.keys(this.templatePage[0].fonts[0]).forEach((key, index) => {
    //     const value = this.templatePage[0].fonts[0][key];
    //     document.documentElement.style.setProperty('--bs-head-font-family', key);
    //     document.documentElement.style.setProperty('--bs-head-font-weight', value);
    //   });
    // }
    // if (this.templatePage[0]?.fonts && this.templatePage[0]?.fonts[1]) {
    //   Object.keys(this.templatePage[0].fonts[1]).forEach((key, index) => {
    //     const value = this.templatePage[0].fonts[0][key];
    //     document.documentElement.style.setProperty('--bs-body-font-family', key);
    //     document.documentElement.style.setProperty('--bs-body-font-weight', value);
    //   })
    // }
  }

  themes: any[] = [];
  getThemePallet() {
    this.templateService.getAllThemePallet().subscribe((res: any) => {
      this.themes = res.data;
    })
  }

  goBack() {
    const dialogRef = this.dialog.open(WarningPopupComponent, {
      width: '400px',
      data: {
        title: 'Exit Confirmation',
        message: 'Are you sure you want to exit? Any unsaved changes will be lost.'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirm' || result === true) {
        localStorage.removeItem('subIndustryId');
        this.router.navigate(['/master/template/v3-template']);
      }
    });
  }
  close() {
    this._eventService.updateTemplateStatus.emit({
      view: true
    })
  }

  selectedGlobal: string = ''
  open(ev: string): void {

    this.selectedGlobal = ev;
  }


  changePage(event, pageName: string) {
    this.currentPageId = event;
    this.selectedPage = pageName
    this.unActivateLink(event);
  }

  savePage() {
    this.getWebsiteLoader = true;
    this.templateData['approvalStatus'] = 'INPROGRESS';
    this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
      this.snackBar.open('Page Updated successfully', 'close', { duration: 1500 });
      this.getWebsiteLoader = false;

    }, () => {
      this.getWebsiteLoader = false;
    })
  }

  showPageList() {
    let dialog = this.templateService.openDialog(CreateNewPageComponent, '90%', '70%', {});
    dialog.afterClosed().subscribe((res: any) => {
      if (res?.page) {
        if (res.page.pageName === 'Home') {
          this.createHomePage(res.page.id);
        }
        else if (res.page.pageName === 'Blank Page') {
          this.createNewPage();
        } else {
          this.createExistingPage(res.page.id);
        }
      }
    })
  }

  createHomePage(pageId: any) {
    this.templateService.getPageBySubIndustryIdNew(pageId, this.templateData.subIndustry.id).subscribe((pageRes: any) => {
      pageRes.data.components.splice(0, 1);
      pageRes.data.components.splice(pageRes.data.components.length - 1, 1);

      let headerComponent = this.templatePage[0].components[0];
      let footerComponent = this.templatePage[0].components[this.templatePage[0].components.length - 1];

      this.templateData.pages[0].components = [];
      this.templateData.pages[0].components.push(headerComponent);
      this.templateData.pages[0].components = [...this.templateData.pages[0].components, ...pageRes.data.components];
      this.templateData.pages[0].components.push(footerComponent);
      // console.log(this.templatePage)
      this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
        this.templateData = res.data;
        this.templatePage = res.data.pages;
        this.changePage(this.templatePage[0].id, pageRes.data.pageName)
      }, (err) => {
        this.getWebsiteLoader = false;
      })
    })
  }

  // createExistingPage(pageId: any) {
  //   this.templateService.getPageBySubIndustryId(this.templateData.subIndustry.id, pageId).subscribe((pageRes: any) => {
  //     pageRes.data.path = '/' + pageRes.data.pageName?.toLowerCase().replace(" ", "-");
  //     this.templatePage.push(pageRes.data);
  //     this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
  //       this.templateData = res.data;
  //       this.templatePage = this.templateData.pages;
  //       this.changePage(this.templatePage[this.templatePage.length - 1].id, pageRes.data.pageName)
  //     }, (err) => {
  //       this.getWebsiteLoader = false;
  //     })
  //   }, () => {
  //     this.snackBar.open('No Page Found');
  //   })
  // }

  createExistingPage(pageId: any) {
    this.templateService.getPageBySubIndustryIdNew(pageId, this.templateData.subIndustry.id).subscribe((pageRes: any) => {
      pageRes.data.path = '/' + pageRes.data.pageName?.toLowerCase().replace(" ", "-");
      pageRes.data.id = null;
      this.templatePage.push(pageRes.data);
      this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
        this.templateData = res.data;
        this.templatePage = this.templateData.pages;
        this.changePage(this.templatePage[this.templatePage.length - 1].id, pageRes.data.pageName)
      }, (err) => {
        this.getWebsiteLoader = false;
      })
    }, () => {
      this.snackBar.open('No Page Found');
    })
  }

  createNewPage() {
    this.getWebsiteLoader = true;
    let pageData: PageData = new PageData();
    pageData.path = this.templatePage.length < 2 ? '/New_Page' : '/New_Page_' + String(this.templatePage.length - 1);
    pageData.pageName = this.templatePage.length < 2 ? 'New Page' : ('New Page ' + String(this.templatePage.length - 1));
    pageData.updatedTimeStamp = new Date()
    pageData.id = '';
    pageData.websiteThemeId = this.templatePage[0].websiteThemeId ? this.templatePage[0].websiteThemeId : this.themes[0].id;

    pageData.components.push(this.createAddSection())
    this.templatePage.push(pageData)

    // ADDING DATA IN HEADER
    // this.addingLinksToHeader(pageData.pageName);

    this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
      //this.templatePage[this.templatePage.length - 1].id = res.data[res.data.length - 1].id;
      this.templateData = res.data;
      this.templatePage = this.templateData.pages;
      this.changePage(this.templatePage[this.templatePage.length - 1].id, pageData.pageName)
    }, (err) => {
      this.getWebsiteLoader = false;
    })
  }

  addingLinksToHeader(pageName: string) {
    if (!this.templatePage[0].components[0].content.navbarButtons || this.templatePage[0].components[0].content.navbarButtons.length == 0) {
      let homePageLink = {
        label: 'Home',
        redirectionUrl: "",
        pageId: this.templatePage[0].id,
        status: false
      }
      this.templatePage[0].components[0].content.navbarButtons.push(homePageLink);
    }
    this.unActivateLink(null);

    let link = {
      label: pageName,
      redirectionUrl: "/new_page",
      pageId: "",
      status: true
    }

    this.templatePage[0].components[0].content.navbarButtons.push(link);
  }

  unActivateLink(pageId: any) {
    for (let link of this.templatePage[0].components[0].content?.navbarButtons) {
      if (link.pageId === pageId) {
        link.status = true;
      } else {
        link.status = false;
      }
    }
  }

  addingPageInHeader(pageName) {
    let header = this.templatePage[0].components[0];
    let navButton = {
      "label": pageName,
      "redirectionUrl": "/newPage",
      "pageId": "",
      "status": true
    }
    header.content.navbarButtons.push(navButton);
  }

  createAddSection() {
    let addSection = new Section();
    addSection.sectionType = 'addNewSection';
    return addSection;
  }


  pageListComponent() {

    let dialog = this.templateService.openDialog(
      PageListComponent,
      '',
      '',
      { data: this.templatePage }
    )

    dialog.afterClosed().subscribe((res: any) => {
      if (!res?.action)
        return;

      if (res.action === 'changePage') {
        this.changePage(res.id, res.pageName)
      }
      else if (res.action === 'addPage') {
        if (res.duplicate) {
          this.createDuplicatePage(res.page);
        } else if (!res.duplicate) {
          this.createNewPage();
        }
        else {
          this.showPageList();
        }
      }
      else if (res.action === 'deletePage') {
        this.deletePage(res.index);
      }
    })

  }

  createDuplicatePage(page: string) {
    this.getWebsiteLoader = true;
    let duplicatePage = JSON.parse(JSON.stringify(page));
    duplicatePage.path = this.templatePage.length < 2 ? '/New_Page' : '/New_Page_' + String(this.templatePage.length - 1);
    duplicatePage.pageName = this.templatePage.length < 2 ? 'New Page' : ('New Page ' + String(this.templatePage.length - 1));
    duplicatePage.updatedTimeStamp = new Date()
    duplicatePage.homePageId = this.templatePage[0].id
    duplicatePage.id = '';

    this.removeHeaderAndFooterIfPresent(duplicatePage);
    this.templatePage.push(duplicatePage)

    this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
      this.templateData = res.data;
      this.templatePage = this.templateData.pages;
      this.changePage(this.templatePage[this.templatePage.length - 1].id, duplicatePage.pageName)
    }, (err) => {
      this.getWebsiteLoader = false;
    })

  }

  removeHeaderAndFooterIfPresent(page: any) {
    if (page.pageName != 'Home') {
      if (page.components[0].sectionType == 'header') {
        page.components.splice(0, 1);
      }
      if (page.components[page.components.length - 1].sectionType === 'footer') {
        page.components.splice(page.components.length - 1, 1);
      }
    }
  }

  deletePage(index: number) {
    this.warningPopup().subscribe((res: any) => {
      if (res.delete) {
        this.getWebsiteLoader = true;
        let deletedPageName = this.templatePage[index].pageName;
        let pageID = this.templatePage[index].id;

        this.templatePage.splice(index, 1);
        this.templateService.createTemplateV4(this.templateData).subscribe((res: any) => {
          this.templateData = res.data;
          this.removingNavigationFromHeader(pageID)
          if (deletedPageName === this.selectedPage) {
            this.changePage(this.templatePage[0].id, this.templatePage[0].pageName);
          } else {
            this.getWebsiteLoader = false
          }
          this.snackBar.open('Page Deleted Successfully', 'close', { duration: 3000 })
        }, () => {
          this.getWebsiteLoader = false;
        })

      }
    })
  }

  removingNavigationFromHeader(pageID: any) {

    let index = -1;
    for (let i = 0; i < this.templatePage[0].components[0].content.navbarButtons.length; i++) {
      let button = this.templatePage[0].components[0].content.navbarButtons[i];
      if (button.pageId === pageID) {
        index = i;
        break;
      }
    }
    if (index != -1) {
      this.templatePage[0].components[0].content.navbarButtons.splice(index, 1);
    }

    if (this.templatePage[0].components[0].content.navbarButtons.length === 1 &&
      this.templatePage[0].components[0].content.navbarButtons[0].pageId === this.templatePage[0].id) {
      this.templatePage[0].components[0].content.navbarButtons.splice(0, 1);
    }
  }

  warningPopup() {
    let width = window.innerWidth > 475 ? '400px' : '94%'
    let height = window.innerWidth > 475 ? '268px' : '200px'
    let warningPopupModel = this.templateService.openDialog(
      WarningPopupComponent,
      height,
      width,
      { data: null }
    );

    return warningPopupModel.afterClosed()
  }

  closeEditor() {
    // console.log('data')/
    this.eventService.showEditor.emit({ data: false })
  }

  viewPerview() {
    window.open(this.businessDetails.domainUrl ? this.businessDetails.domainUrl : this.businessDetails.websiteUrl, '_blank')?.focus();
  }


  screenType: 'DESKTOP' | 'TAB' | 'MOBILE' = 'DESKTOP'; // default value

  changeScreen(type: 'DESKTOP' | 'TAB' | 'MOBILE') {
    this.screenType = type;

  }

  openUploadDialog() {
    const dialogRef = this.dialog.open(UploadTemplateThumbnailComponent, {
      width: '400px',
      data: { data: this.templateData }
    });

    dialogRef.afterClosed().subscribe((file) => {
      if (file) {
        // this.dialogRef.close();
        this.router.navigate(['/master/template/v3-template'])
        console.log('Uploaded file:', file);
      }
    });
  }

  showSideEditor: boolean = false;

  editPage(element: any, isPreview: boolean = false) {
    this.router.navigate(['/master/template/v3-add-page'], { queryParams: { data: JSON.stringify(element), edit: true, isPreview: isPreview, urlFrom: 'create-template', templateData: this.data } })
    // this.templateService.goBackPage.emit(this.data);
    // let dialog = this.templateService.openDialogWithData(
    //   AddPageV3Component,
    //   '100vh',
    //   '100%',
    //   { data: element, edit: true, isPreview: isPreview }
    // )

  }
  // Font Families
  public selectedFont: string | null = null;

  selectedFontFamily(item) {
    this.selectedFont = item.text;
    // if (item.headingFontValues && typeof item.headingFontValues.fontFamily === 'string') {
    //   // Set the custom property on the document root
    //   document.documentElement.style.setProperty('--bs-head-font-family', item.headingFontValues.fontFamily);
    // }
    // if (item.headingFontValues && typeof item.headingFontValues.fontWeight === 'string') {
    //   document.documentElement.style.setProperty('--bs-head-font-weight', item.headingFontValues.fontWeight);
    // }
    // if (item.bodyFontValues && typeof item.bodyFontValues.fontFamily === 'string') {
    //   document.documentElement.style.setProperty('--bs-body-font-family', item.bodyFontValues.fontFamily)
    // }
    // if (item.bodyFontValues && typeof item.bodyFontValues.fontWeight === 'string') {
    //   document.documentElement.style.setProperty('--bs-body-font-weight', item.bodyFontValues.fontWeight);
    // }
    document.documentElement.style.setProperty('--website-font-family', item.text);
    for (let page of this.templatePage) {
      let selectedFontFamily = item.text
      page.fonts = []

      let fontWeights = ['900', '400'];

      for (let weight of fontWeights) {
        const fontObj = { [selectedFontFamily]: weight };
        page.fonts.push(fontObj);
      }

      console.log(page.fonts)
      // heading[item.headingFontValues.fontFamily] = item.headingFontValues.fontWeight;

      // let desc = {};
      // desc[item.bodyFontValues.fontFamily] = item.bodyFontValues.fontWeight;

      // page.fonts.push(heading)
      // page.fonts.push(desc)
    }

  }
  loader = false;
}

